const SCROLL_KEY = 'portfolio-home-scroll';
const STATE_KEY = 'portfolio-home-state';

export const saveHomePosition = (state = {}) => {
    sessionStorage.setItem(SCROLL_KEY, String(window.scrollY));
    sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
};

export const clearHomeMemory = () => {
    sessionStorage.removeItem(SCROLL_KEY);
    sessionStorage.removeItem(STATE_KEY);
};

export const consumeHomeScroll = () => {
    const value = sessionStorage.getItem(SCROLL_KEY);
    if (value == null) return null;
    sessionStorage.removeItem(SCROLL_KEY);
    return Number(value);
};

export const consumeHomeState = () => {
    const value = sessionStorage.getItem(STATE_KEY);
    if (value == null) return null;
    sessionStorage.removeItem(STATE_KEY);
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};
